import QuickBooksDesktop from "./QuickBooksDesktop";
import QuickBooksOnline from "./QuickBooksOnline";
import useGetShopSettings from "@/lib/queries/useGetShopSettings";
import useUpdateShopSettings from "@/lib/queries/useUpdateShopSettings";
import { useParams } from "react-router";
import SettingsSectionLayout from "@/lib/SettingsSectionLayout";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";

export default function AccountingSystem() {
  const { teamSlug } = useParams();
  const shopData = useGetShopSettings(teamSlug).data;
  const setShopSettings = useUpdateShopSettings();
  const queryClient = useQueryClient();

  return (
    <div className="flex flex-col gap-4">
      <SettingsSectionLayout title="Accounting System">
        <label className="flex flex-col gap-1">
          <span className="font-medium">Select Accounting System</span>
          <select
            className="border rounded px-2 py-1"
            value={shopData?.accounting_system ?? ""}
            onChange={async (e) => {
              const val = e.target.value;
              await setShopSettings(
                {
                  body: {
                    accounting_system:
                      val === "" ? null : (val as "qbo" | "qbd"),
                  },
                  params: {
                    path: {
                      team_slug: teamSlug!,
                    },
                  },
                },
                {
                  onSuccess: () => {
                    toast.success("Shop settings updated");
                  },
                },
              );
              // When the user switches accounting systems (rare in real-world use), we clear the query cache
              // to ensure that the new system's data is fetched fresh.
              queryClient.clear();
            }}
          >
            <option value="">None</option>
            <option value="qbo">QuickBooks Online</option>
            <option value="qbd">QuickBooks Desktop</option>
          </select>
        </label>
      </SettingsSectionLayout>

      {shopData?.accounting_system_name === "QuickBooks Online" ? (
        <QuickBooksOnline />
      ) : shopData?.accounting_system_name === "QuickBooks Desktop" ? (
        <QuickBooksDesktop />
      ) : (
        <div className="text-red-600">
          No accounting system is configured for this team.
        </div>
      )}
    </div>
  );
}
